import axios from "../../utils/axios";

export const getAssets = async ({ category }) => {
  const res = await axios.get("asset/getList", {
    params: {
      category,
    },
  });

  return res;
};

export const getAssetById = async (id) => {
  const res = await axios.get(`asset/${id}`);

  return res;
};

export const deleteAssetById = async (id) => {
  const res = await axios.delete(`asset/${id}`);

  return res;
};

export const createAsset = async (values) => {
  const res = await axios.post("asset/create", values);

  return res;
};
